import agentAdministration from 'Users/ducks/agentAdministration';
import agentNumber from 'Users/ducks/agentNumber';
import agentProfile from 'Users/ducks/agentProfile';
import agentSignUp from 'Users/ducks/agentSignUp';
import agentSupportUserType from 'Users/ducks/agentSupportUserType';
import agentUser from 'Users/ducks/agentUser';
import agentVerification from 'Users/ducks/agentVerification';
import bosAndBeneficiariesUser from 'Users/ducks/bosAndBeneficiariesUserCreation';
import fieldSalesLeaderUser from 'Users/ducks/fieldSalesLeaderUser';
import fieldVicePresidentUser from 'Users/ducks/fieldVicePresidentUser';
import fieldVicePresidentUserType from 'Users/ducks/fieldVicePresidentUserType';
import independentAgent from 'Users/ducks/independentAgent';
import passwordRecovery from 'Users/ducks/passwordRecovery';
import recruiterCode from 'Users/ducks/recruiterCode';
import registration from 'Users/ducks/registration';
import sso from 'Users/ducks/SSO';
import userAccount from 'Users/ducks/userAccount';
import userAdministration from 'Users/ducks/userAdministration';
import userEntry from 'Users/ducks/userEntry';
import userEntryEdit from 'Users/ducks/userEntryEdit';
import userProfile from 'Users/ducks/userProfile';
import userRecovery from 'Users/ducks/userRecovery';
import validate from 'Users/ducks/validate';
import vipUser from 'Users/ducks/vipUser';
import customerSupport from 'Users/ducks/CustomerSupport';

export default {
  agentAdministration,
  agentNumber,
  agentProfile,
  agentSignUp,
  agentUser,
  agentVerification,
  fieldSalesLeaderUser,
  fieldVicePresidentUser,
  independentAgent,
  passwordRecovery,
  profile: userProfile,
  recruiterCode,
  registration,
  sso,
  userAccount,
  userAdministration,
  userEntry,
  userEntryEdit,
  userRecovery,
  validate,
  vipUser,
  fieldVicePresidentUserType,
  bosAndBeneficiariesUser,
  agentSupportUserType,
  customerSupport,
};
